import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { PrestamoAbonoService } from 'src/app/services/prestamo-abono/prestamo-abono.service';
import { ConvenioAbonoService } from 'src/app/services/convenio-abono/convenio-abono.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';


export interface DialogData {
  idConvenio: any,
  tipoConvenioString: any,
  nombreRegion: any,
  idPlanPago: any
  archivos: any
  idPostulacion: any
  montoSolicitado: any
  rutUsuario: any
  nombreUsuario: any
  apellidoUsuario: any
  rol: any
  regionConvenio: any
  recarga: any
  cantidadCuota: any
  idCodeudor1: any
  idCodeudor2: any
  montoCuota: any
  fechaPrimerPago: any
  deshabilitado: boolean
  presionaEditar: boolean
  mostrarEditar: any
  disponiblePago: any
  idCantidadCuota: any,
  mostrarAprobarButton: any
  rutCodeudor1: any
  nombreCodeudor1: any
  apellidoCodeudor1: any
  rutCodeudor2: any
  nombreCodeudor2: any
  apellidoCodeudor2: any
  totalMaximo: any
  idUsuario: any
  tipos: any
  cuotas: any
  planes: any
  numCuota: any
  tasaInteres: any
  valorCuota: any
  region: any
  nombreCorto: any
  nombreProveedor: any
  editable: any
}

declare const Rut: any;
@Component({
  selector: 'app-convenio-pago',
  templateUrl: '../../pages/convenio-abono/convenio-pago.html',
  styleUrls: ['../../pages/convenio-abono/convenio-abono.component.css']
})
export class DialogPagoConvenio implements OnInit {

  prestamos: any
  planes: any
  user: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  tipoPostulacion: string = "Pagadas"
  allComplete: boolean = false
  prestamoSolicitado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  nombreUsuario: any
  rutUsuario: any
  totalMaximo: any
  router: any
  cantidadArchivos = 1
  deshabilitado: true
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };

  pagoConvenio: any = {
    montoSolicitado: this.data.montoSolicitado,
    idPostulacion: this.data.idPostulacion,
    idConvenio: this.data.idConvenio,
    cantidadCuotas: this.data.numCuota,
    region: this.data.nombreRegion,
    idUsuario: localStorage.getItem("idUsuario"),
    idPlanPago: this.data.idPlanPago,
    idAfiliado: this.data.idUsuario,
    idCodeudor1: this.data.idCodeudor1,
    idCodeudor2: this.data.idCodeudor2,
    tipoConvenio: this.data.tipoConvenioString,
    archivo: [], archivoTest: null,
    planes: []
  }

  constructor(public dialogRef: MatDialogRef<DialogPagoConvenio>,
    public prestamoAbonoService: PrestamoAbonoService, public convenioAbonoService: ConvenioAbonoService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog) {
    this.data.recarga = false
  }


  ngOnInit(): void { this.loadData() }

  loadData() {

  }

  pageChanged(event: any) {
    this.config.currentPage = event

    this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
    this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() { this.router.navigate(['/index']) }


  verPlanPago(idConvenio: any) {
    this.convenioAbonoService.traePlanPagoConvenio(idConvenio).then(
      planes => {
        this.planes = planes
        console.log(planes)
      }
    ).catch(error => console.log(error))

  }

  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      // console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.pagoConvenio.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.pagoConvenio.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      }
    }
  }

  onCancelarClick() { this.dialogRef.close() }

  onAgregarPagoClick(form: NgForm) {

    let vm = this;
    if (this.pagoConvenio.archivoTest == null) {
      this.openAlertDialog('Por favor, adjunte un comprobante de pago', 'btn-danger')

      Swal.close();
      return false
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de Ingresar la Solicitud de Pago de Convenio?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {

        if (confirmed) {
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();

          let sizeArchivos = 0;
          for (let i = 0; i < this.cantidadArchivos; i++) {
            sizeArchivos += this.pagoConvenio.archivo[i].size;
            if (sizeArchivos > 25000000) {
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();
              return;
            }
            this.pagoConvenio.archivo[i].sizeArchivos;
            if (this.pagoConvenio.archivo[i].extension != "application/pdf" && this.pagoConvenio.archivo[i].extension != "image/jpeg" &&
              this.pagoConvenio.archivo[i].extension != "image/jpg" && this.pagoConvenio.archivo[i].extension != "image/png") {
              this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')

              Swal.close();
              return false
            }

          }

          this.prestamoAbonoService.ingresarPago(localStorage.getItem("idUsuario"), this.pagoConvenio).then(
            () => {             
              this.pagoConvenio.archivo = [];
              this.openAlertDialog('La solicitud de pago de Convenio fue ingresada exitosamente, aún debe ser validado.', 'btn-success')
              form.reset();
              this.verPlanPago(this.pagoConvenio.idConvenio)
            
              this.dialogRef.close()
              Swal.close();
            }
          )
            .catch(error => {
              console.log(error)
              Swal.close();
              this.openAlertDialog('Ha ocurrido un error al ingresar un pago.', 'btn-danger')
            })
        }
      })
    }
  }


}
